<ng-container appFormRegistration [parentForm]="form">
<h5 class="form-section-title">รายละเอียดข้อมูลธุรกิจ (สำหรับบุคคลธรรมดา)</h5>
@if (formData.individualOwnerName) {
  <p class="mb-3">
    <span class="text-secondary">ผู้ประกอบการ</span>
    <span class="fw-semibold ms-2">{{ formData.individualOwnerName }}</span>
  </p>
}

<h6 class="form-group-heading">ข้อมูลธุรกิจ</h6>
<div class="row g-3 mb-3">
  <div class="col-12 col-md-6">
    <label class="form-label" for="individualTaxId">เลขประจำตัวผู้เสียภาษี <span class="text-danger">*</span></label>
    <input id="individualTaxId" type="text" class="form-control form-control-sm" name="taxId"
           [(ngModel)]="formData.model.taxId" #taxIdRef="ngModel" required
           [readonly]="formData.individualTaxIdLocked"
           [class.is-invalid]="taxIdRef.invalid && taxIdRef.touched">
    @if (formData.individualTaxIdLocked) {
      <div class="form-text">ใช้เลขประจำตัวประชาชนของคุณ แก้ไขไม่ได้</div>
    }
    @if (taxIdRef.invalid && taxIdRef.touched) {
      <div class="invalid-feedback d-block">กรุณากรอกเลขประจำตัวผู้เสียภาษี</div>
    }
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label" for="individualBusinessName">ชื่อธุรกิจ <span class="text-danger">*</span></label>
    <input id="individualBusinessName" type="text" class="form-control form-control-sm" name="title"
           [(ngModel)]="formData.model.title" #titleRef="ngModel" required
           [class.is-invalid]="titleRef.invalid && titleRef.touched">
    @if (titleRef.invalid && titleRef.touched) {
      <div class="invalid-feedback d-block">กรุณากรอกชื่อธุรกิจ</div>
    }
  </div>
  <div class="col-12">
    <label class="form-label">ประเภทธุรกิจ <span class="text-danger">*</span></label>
    <input type="hidden" name="businessTypeIds" [ngModel]="formData.selectedBusinessTypeIds"
           #businessTypesRef="ngModel" required>
    <div class="business-type-groups">
      @for (group of formData.businessTypeGroups; track group.stage) {
        <div class="business-type-group">
          <div class="business-type-group-title">
            <span class="business-type-stage" [attr.data-stage]="group.stage">{{ group.label }}</span>
            <small class="text-muted">{{ group.hint }}</small>
          </div>
          <div class="row row-cols-1 row-cols-md-2 g-1">
            @for (option of group.types; track option.id) {
              <div class="col">
                <div class="form-check" [class.is-inactive]="!formData.isBusinessTypeActive(option)">
                  <input class="form-check-input" type="checkbox" [id]="'individualBusinessType' + option.id"
                         [checked]="formData.isBusinessTypeSelected(option.id)"
                         (change)="formData.toggleBusinessType(option.id, $any($event.target).checked)">
                  <label class="form-check-label" [for]="'individualBusinessType' + option.id">
                    {{ option.title }}
                    @if (!formData.isBusinessTypeActive(option)) {<span class="business-type-inactive">ปิดใช้งาน</span>}
                  </label>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
    @if (businessTypesRef.invalid && businessTypesRef.touched) {
      <div class="invalid-feedback d-block">กรุณาเลือกประเภทธุรกิจอย่างน้อย 1 ประเภท</div>
    }
  </div>
  <div class="col-12">
    <label class="form-label" for="individualBusinessNameEn">ชื่อธุรกิจ (EN)</label>
    <input id="individualBusinessNameEn" type="text" class="form-control form-control-sm" name="titleEn"
           [(ngModel)]="formData.model.titleEn">
  </div>
  <div class="col-12">
    <label class="form-label" for="individualBusinessDescription">รายละเอียดธุรกิจ</label>
    <textarea
      id="individualBusinessDescription"
      class="form-control form-control-sm"
      name="detail"
      [(ngModel)]="formData.model.detail"
      rows="4"
      placeholder="อธิบายสินค้า บริการ หรือรูปแบบธุรกิจโดยย่อ"></textarea>
  </div>
  <div class="col-12">
  <div class="d-flex align-items-center gap-2">
    <label class="form-label mb-0">
      ใบรับรองที่ใช้กับธุรกิจนี้
      @if (formData.certificateOptional) {<span class="text-secondary small fw-normal">(ไม่บังคับสำหรับประเภทที่เลือก)</span>} @else {<span class="text-danger">*</span> <span class="requirement-note">บังคับเพราะเลือก {{ formData.certificateRequiredNote }}</span>}
    </label>
    <app-certificate-sync-button [taxId]="formData.model.taxId"
                                  [ownIdentity]="formData.individualTaxIdLocked"
                                  (synced)="formData.onCertificatesSynced()"></app-certificate-sync-button>
    <app-certificate-add-button [taxId]="formData.model.taxId"
                                [ownerName]="formData.model.title"
                                (added)="formData.onCertificateAdded($event)"></app-certificate-add-button>
  </div>
  <input type="hidden" name="certificateNos" [ngModel]="formData.selectedCertificateKeys" #certNos="ngModel" [required]="!formData.certificateOptional">
  <app-certificate-select [items]="formData.certificateOptions" [control]="certNos.control"
                          (selectionChange)="formData.onCertificateSelectionChange($event)"
                          size="sm"></app-certificate-select>
  @if (certNos.invalid && certNos.touched) {
    <div class="invalid-feedback d-block">กรุณาเลือกอย่างน้อย 1 ใบรับรอง</div>
  }
  </div>
  <div class="col-12">
    <label class="form-label" for="individualRegistrationDocument">หลักฐานการจดทะเบียนพาณิชย์</label>
    <app-file-upload
      inputId="individualRegistrationDocument"
      accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
      hint="ไฟล์ PDF, PNG, JPG ขนาดไม่เกิน 5 MB">
    </app-file-upload>
  </div>
</div>

<h6 class="form-group-heading">ที่อยู่</h6>
<div class="row g-3 mb-3">
<!--  @if (formData.certificateOptions.length > 0) {-->
<!--    <div class="col-12">-->
<!--      <label class="form-label" for="individualAddressPreset">เลือกที่ตั้งจากใบรับรอง</label>-->
<!--      <ng-select-->
<!--        id="individualAddressPreset"-->
<!--        [items]="formData.hqAddressOptions"-->
<!--        bindLabel="text"-->
<!--        [clearable]="true"-->
<!--        [searchable]="true"-->
<!--        [disabled]="formData.individualManualAddress()"-->
<!--        [(ngModel)]="formData.selectedIndividualAddress"-->
<!--        [ngModelOptions]="{ standalone: true }"-->
<!--        (search)="formData.searchAddress($event.term, 'hq')"-->
<!--        (change)="formData.onAddressSelected($event, 'individual')"-->
<!--        placeholder="-เลือกที่ตั้ง-">-->
<!--      </ng-select>-->
<!--    </div>-->
<!--    <div class="col-12">-->
<!--      <div class="form-check">-->
<!--        <input class="form-check-input" id="individualManualAddress" type="checkbox"-->
<!--               [checked]="formData.individualManualAddress()"-->
<!--               (change)="formData.setManualAddress('individual', $any($event.target).checked)">-->
<!--        <label class="form-check-label" for="individualManualAddress">ระบุเองด้วยตนเอง</label>-->
<!--      </div>-->
<!--    </div>-->
<!--  }-->
  <div class="col-12">
    <label class="form-label">เลขที่ <span class="text-danger">*</span></label>
    <input type="text" class="form-control form-control-sm" name="addressNo"
           [(ngModel)]="formData.model.addressNo" #addressNoRef="ngModel" required
           [class.is-invalid]="addressNoRef.invalid && addressNoRef.touched">
    @if (addressNoRef.invalid && addressNoRef.touched) {
      <div class="invalid-feedback d-block">กรุณากรอกเลขที่</div>
    }
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">ตรอก/ซอย</label>
    <input type="text" class="form-control form-control-sm" name="soi"
           [(ngModel)]="formData.model.soi">
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">ถนน</label>
    <input type="text" class="form-control form-control-sm" name="street"
           [(ngModel)]="formData.model.street">
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">ตำบล/แขวง <span class="text-danger">*</span></label>
    <app-subdistrict-autocomplete
      name="subDistrict"
      [ngModel]="formData.subDistrict"
      (ngModelChange)="formData.onSubDistrictChange($event)"
      #subdistrictRef="ngModel"
      [required]="true"
      size="sm">
    </app-subdistrict-autocomplete>
    @if (subdistrictRef.invalid && subdistrictRef.touched) {
      <div class="invalid-feedback d-block">กรุณาเลือกตำบล/แขวง</div>
    }
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">อำเภอ/เขต</label>
    <input type="text" class="form-control form-control-sm" name="districtName"
           [(ngModel)]="formData.districtName" readonly disabled>
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">จังหวัด</label>
    <input type="text" class="form-control form-control-sm" name="provinceName"
           [(ngModel)]="formData.provinceName" readonly disabled>
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">รหัสไปรษณีย์</label>
    <input type="text" class="form-control form-control-sm" name="zipcode"
           [(ngModel)]="formData.model.zipcode" maxlength="5" readonly disabled>
  </div>
  <div class="col-12">
    <label class="form-label">อีเมล <span class="text-danger">*</span></label>
    <input type="email" class="form-control form-control-sm" name="email"
           [(ngModel)]="formData.model.email" #emailRef="ngModel" required
           [class.is-invalid]="emailRef.invalid && emailRef.touched">
    @if (emailRef.invalid && emailRef.touched) {
      <div class="invalid-feedback d-block">กรุณากรอกอีเมล</div>
    }
  </div>
</div>

<h6 class="form-group-heading">ช่องทางติดต่อ</h6>
<div class="row g-3 mb-3">
  <div class="col-12 col-md-6">
    <label class="form-label">โทรศัพท์ <span class="text-danger">*</span></label>
    <input type="tel" class="form-control form-control-sm" name="phone"
           [(ngModel)]="formData.model.phone" #phoneRef="ngModel" required
           [class.is-invalid]="phoneRef.invalid && phoneRef.touched">
    @if (phoneRef.invalid && phoneRef.touched) {
      <div class="invalid-feedback d-block">กรุณากรอกเบอร์โทรศัพท์</div>
    }
  </div>
  <div class="col-12 col-md-6">
    <label class="form-label">โทรศัพท์ (เพิ่มเติม)</label>
    <input type="tel" class="form-control form-control-sm" name="fax"
           [(ngModel)]="formData.model.fax">
  </div>
  <div class="col-12">
    <label class="form-label">เว็บไซต์</label>
    <input type="text" class="form-control form-control-sm" name="webSite"
           [(ngModel)]="formData.model.webSite">
  </div>
  <div class="col-12">
    <label class="form-label">
      ตำแหน่งบนแผนที่
      @if (formData.locationRequired) {<span class="text-danger">*</span> <span class="requirement-note">บังคับเพราะเลือก {{ formData.locationRequiredNote }}</span>} @else {<span class="text-secondary small fw-normal">(ไม่บังคับสำหรับประเภทที่เลือก)</span>}
    </label>
    <div class="d-flex gap-2 align-items-center">
      <input id="individualLatitude" type="text" class="form-control form-control-sm maxw-125px" name="latitude"
             [(ngModel)]="formData.model.latitude" readonly placeholder="ละติจูด"
             #latitudeRef="ngModel" [required]="formData.locationRequired"
             [class.is-invalid]="latitudeRef.invalid && latitudeRef.touched">
      <input id="individualLongitude" type="text" class="form-control form-control-sm maxw-125px" name="longitude"
             [(ngModel)]="formData.model.longitude" readonly placeholder="ลองจิจูด">
      <button class="btn btn-sm btn-outline-primary-accent d-inline-flex align-items-center gap-1 text-nowrap"
              type="button" (click)="formData.openLocationPicker('individual')">
        <i class="bi bi-geo-alt"></i>
        <span>เลือกแผนที่</span>
      </button>
    </div>
    @if (latitudeRef.invalid && latitudeRef.touched) {
      <div class="invalid-feedback d-block">กรุณาเลือกตำแหน่งบนแผนที่</div>
    }
    <div class="form-text">คลิก "เลือกแผนที่" เพื่อระบุตำแหน่งของธุรกิจบนแผนที่</div>
  </div>
</div>

<h6 class="form-group-heading">สถานะใช้งาน</h6>
<div class="mb-3">
  <div class="form-check form-check-inline">
    <input class="form-check-input" id="individualStatusActive" type="radio" name="state"
           [(ngModel)]="formData.isActive" [value]="true">
    <label class="form-check-label" for="individualStatusActive">ใช้งาน</label>
  </div>
  <div class="form-check form-check-inline">
    <input class="form-check-input" id="individualStatusInactive" type="radio" name="state"
           [(ngModel)]="formData.isActive" [value]="false">
    <label class="form-check-label" for="individualStatusInactive">ไม่ใช้งาน</label>
  </div>
</div>
</ng-container>
